<div class="dialog-container">
    <header class="dialog__header">
        <h2 class="title__container">Aiutaci a migliorare il servizio!</h2>
        <div class="close-dialog">
            <button
                mat-icon-button
                mat-dialog-close
                class="button-close--outlined"
                color="primary"
                aria-label="Chiudi"
            >
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </header>

    <div class="dialog__body">
        <div class="description__container">
            <p class="description__lead">Come ti sei trovato con il servizio?</p>
            <p class="description__text">
                Esprimi il tuo giudizio cliccando sulle faccine in base del tuo
                grado di soddisfazione
            </p>
        </div>

        <div class="smiles__container">
            <button
                type="button"
                class="smile"
                aria-label="Soddisfatto"
                (click)="satisfactionAccepted(SATISFACTION.SATISFACTED)"
            >
                <mat-icon
                    class="icon__satisfied"
                    [class.icon__disabled]="
                        satisfactionSelected &&
                        satisfactionSelected !== SATISFACTION.SATISFACTED
                    "
                >
                    sentiment_very_satisfied
                </mat-icon>
            </button>
            <button
                type="button"
                class="smile"
                aria-label="Neutrale"
                (click)="satisfactionAccepted(SATISFACTION.NEUTRAL)"
            >
                <mat-icon
                    class="icon__neutral"
                    [class.icon__disabled]="
                        satisfactionSelected &&
                        satisfactionSelected !== SATISFACTION.NEUTRAL
                    "
                >
                    sentiment_satisfied
                </mat-icon>
            </button>
            <button
                type="button"
                class="smile"
                aria-label="Insoddisfatto"
                (click)="satisfactionAccepted(SATISFACTION.DISFACTED)"
            >
                <mat-icon
                    class="icon__dissatisfied"
                    [class.icon__disabled]="
                        satisfactionSelected &&
                        satisfactionSelected !== SATISFACTION.DISFACTED
                    "
                >
                    sentiment_dissatisfied
                </mat-icon>
            </button>
        </div>

        <mat-form-field appearance="fill" class="fo-field notes__field">
            <mat-label>Note</mat-label>
            <textarea
                matInput
                placeholder="Scrivi il tuo feedback"
                [(ngModel)]="feedback"
            ></textarea>
        </mat-form-field>
    </div>

    <div class="cta__container">
        <button
            type="button"
            class="fo-btn fo-btn--primary"
            [disabled]="!satisfactionSelected || submitted"
            (click)="sendSatisfaction()"
        >
            Invia
        </button>
    </div>
</div>
